import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../App';
const PublicRoutes = () => {
  let value = React.useContext(AuthContext);

  return value.isAuthenticated === 'true' ? <Navigate to="/dashboard" /> : <Outlet />;
};
export default PublicRoutes;
